import { NavItems } from "@helpers/navigation";
import { useLocation } from "react-router-dom";
import { BasicProps } from "../../../common/components/ComponentsInterface";
import { LHero } from "../../../common/components/LHero";

export const SignupLandingShell = ({ ...props }: SignupLandingShellProps): JSX.Element => {
    const { pathname } = useLocation();

    return (
        <>
            <LHero size="small" type="primary" includeUnauthenticatedMenu={true} centered={true}>
                <div className="pb-6">
                    <img src="/i-Function_logo-white3.png" />
                </div>
            </LHero>
            <div className="container">
                <div className="columns is-centered">
                    <div style={{ position: "absolute", left: 0 }}>{props.floatingLeftElement}</div>
                    <div
                        className={`column ${
                            pathname === NavItems.Signup.UserCreated.path || pathname === NavItems.Signup.Terms.path
                                ? "is-full"
                                : "is-half"
                        }`}
                    >
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );
};

interface SignupLandingShellProps extends BasicProps {
    floatingLeftElement?: JSX.Element;
}
